import ErrorBox from "../components/Error/Box";
import TeamsSidebar from "@/components/Sidebars/Teams";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import ChannelSidebar from "../components/Sidebars/Team/Channels";
import { useParams, useNavigate } from "react-router-dom";
import ChannelCheck from "./Channel/channel";
import MembersSidebar from "@/components/Sidebars/Team/Members";
import Icon from "@/icons";
import { useEffect, useRef, useState } from "react";
import Hammer from "hammerjs";
import Bottom from "./Bottom/Bottom";
import { Role } from "types";
import { useVoice } from "@/VoiceSystem";
import StreamerModeAlert from "@/components/Error/Alerts/StreamerMode";
import VerifyEmailAlert from "@/components/Error/Alerts/VerifyEmail";
import OpenNotifications from "@/components/Error/Alerts/OpenNotifications";
import { useMediaQuery } from '@mui/material';

const useFetchData = (key: string[], url: string, enabled: boolean) => {
    return useQuery({
        queryKey: key,
        retry: 1,
        retryDelay: 1000,
        refetchOnReconnect: false,
        refetchOnWindowFocus: false,
        enabled,
        queryFn: async () => {
            const response = await fetch(url);
            return response.json();
        }
    });
};

export default function TeamDisplay({ socket }: { socket: any }) {
    const queryClient = useQueryClient();
    const { teamId, channelId } = useParams();
    const [channelList, setChannelList] = useState<any[]>([]);
    const navigate = useNavigate();
    const useQueryClients = useQueryClient();
    const handleSocketMessage = (event: any, membersMe: any, queryClient: any, teamId: string, roles: any) => {
        const data = JSON.parse(event.data);
    };


    const handleChannelEvents = (event: MessageEvent, setChannelList: any, teamId: string) => {
        const data = JSON.parse(event.data);
        switch (data.t) {
            case "CHANNEL_CREATED":
                if (data.d.channel.teamId === teamId) {
                    useQueryClients.setQueryData(["team", teamId, "channels"], { channels: [...((useQueryClients.getQueryData(["team", teamId, "channels"]) as any)?.channels || []), data.d.channel] });
                    setChannelList((prevChannels: any[]) => [...prevChannels, data.d.channel]);
                }
                break;
            case "CHANNEL_DELETED":
                useQueryClients.setQueryData(["team", teamId, "channels"], { channels: (useQueryClients.getQueryData(["team", teamId, "channels"]) as any)?.channels.filter((channel: any) => channel.id !== data.d.channelId) });
                setChannelList((prevChannels: any) => prevChannels.filter((channel: any) => channel.id !== data.d.channelId));
                break;
            case "CHANNEL_UPDATED":
                setChannelList((prevChannels: any) => {
                    const index = prevChannels.findIndex((channel: any) => channel.id === data.d.channel.id);
                    if (index === -1) return prevChannels;
                    const updatedChannels = [...prevChannels];
                    updatedChannels[index] = data.d.channel;
                    return updatedChannels;
                });
                useQueryClients.setQueryData(["team", teamId, "channels"], { channels: (useQueryClients.getQueryData(["team", teamId, "channels"]) as any)?.channels.map((channel: any) => channel.id === data.d.channel.id ? data.d.channel : channel) });
                break;
            case "USER_JOINED_VOICE_CHANNEL":
                setChannelList((prevChannels: any) => {
                    const index = prevChannels.findIndex((channel: any) => channel.id === data.d.channelId);
                    if (index === -1) return prevChannels;
                    const updatedChannels = [...prevChannels];
                    const findParticipant = updatedChannels[index].participants.find((member: any) => member.id === data.d.user.id);
                    if (findParticipant) {
                        findParticipant.isConnecting = false;
                    } else {
                        updatedChannels[index].participants.push({ id: data.d.user.id, isMuted: false, isDeafned: false, isConnecting: false, attendeeId: data.d.attendeeId });
                    }
                    if (!updatedChannels[index].additionalData) updatedChannels[index].additionalData = {};
                    if (!updatedChannels[index].additionalData?.attendeeById) updatedChannels[index].additionalData.attendeeById = {};
                    if (updatedChannels[index].additionalData && updatedChannels[index].additionalData?.attendeeById) {
                        updatedChannels[index].additionalData.attendeeById[data.d.user.id] = data.d.attendeeId;
                    }
                    return updatedChannels;
                });

                useQueryClients.setQueryData(["team", teamId, "channels"], {
                    channels: (useQueryClients.getQueryData(["team", teamId, "channels"]) as any)?.channels.map((channel: any) =>
                        channel.id === data.d.channelId ? {
                            ...channel,
                            participants: [
                                ...channel.participants.filter((participant: any) => participant.id !== data.d.user.id),
                                { id: data.d.user.id, isMuted: false, isDeafned: false, isConnecting: false, attendeeId: data.d.attendeeId }
                            ]
                        } : channel
                    )
                });
                break;
            case "USER_LEFT_VOICE_CHANNEL":
                setChannelList((prevChannels: any) => {
                    const index = prevChannels.findIndex((channel: any) => channel.id === data.d.channelId);
                    if (index === -1) return prevChannels;
                    const updatedChannels = [...prevChannels];
                    updatedChannels[index].participants = updatedChannels[index].participants.filter((member: any) => member.id !== data.d.user.id);
                    if (updatedChannels[index].additionalData && updatedChannels[index].additionalData?.attendeeById) {
                        delete updatedChannels[index].additionalData.attendeeById[data.d.user.id];
                    }
                    return updatedChannels;
                });
                useQueryClients.setQueryData(["team", teamId, "channels"], { channels: (useQueryClients.getQueryData(["team", teamId, "channels"]) as any)?.channels.map((channel: any) => channel.id === data.d.channelId ? { ...channel, participants: channel.participants.filter((member: any) => member.id !== data.d.user.id) } : channel) });
                break;
            case "USER_UPDATED_VOICE_METADATA":
                setChannelList((prevChannels: any) => {
                    const index = prevChannels.findIndex((channel: any) => channel.id === data.d.channelId);
                    if (index === -1) return prevChannels;
                    const updatedChannels = [...prevChannels];
                    const findParticipant = updatedChannels[index].participants.find((member: any) => member.id === data.d.user.id);
                    if (findParticipant) {
                        if (data.d.isMuted !== undefined) findParticipant.isMuted = data.d.isMuted;
                        if (data.d.isDeafened !== undefined) findParticipant.isDeafened = data.d.isDeafened;
                        if (data.d.isStreaming !== undefined) findParticipant.isStreaming = data.d.isStreaming;
                    }
                    return updatedChannels;
                });
                useQueryClients.setQueryData(["team", teamId, "channels"], { channels: (useQueryClients.getQueryData(["team", teamId, "channels"]) as any)?.channels.map((channel: any) => channel.id === data.d.channelId ? { ...channel, participants: channel.participants.map((member: any) => member.id === data.d.user.id ? { ...member, isMuted: data.d.isMuted, isDeafened: data.d.isDeafened, isStreaming: data.d.isStreaming } : member) } : channel) });
                break;
            case "CHANNELS_PRIORITY_UPDATED":
                useQueryClients.setQueryData(["team", teamId, "channels"], {
                    channels: (useQueryClients.getQueryData(["team", teamId, "channels"]) as any)?.channels.map((channel: any) => {
                        const index = data.d.order.indexOf(channel.id);
                        if (index === -1) return channel;
                        return { ...channel, priority: index };
                    }).sort((a: any, b: any) => a.priority - b.priority)
                });
                break;
            default:
                break;
        }
    };

    const query = useQueryClients.getQueryState(["user"]) as any;
    useEffect(() => {
        if (query.status != "success" && !query.data?.user) window.location.href = "/";
    }, [query]);

    const teamDetails = useFetchData(["team", teamId || ''], `__SITE_BASE__/api/v1/teams/${teamId || ''}/details`, !!query.data?.user);
    const channels = useFetchData(["team", teamId || '', "channels"], `__SITE_BASE__/api/v1/teams/${teamId}/channels`, !!teamDetails.data?.team);
    const membersMe = useFetchData(["team", teamId || '', "members", "@me"], `__SITE_BASE__/api/v1/teams/${teamId}/members/@me`, !!teamDetails.data?.team);
    useFetchData(["team", teamId || '', "members"], `__SITE_BASE__/api/v1/teams/${teamId}/members`, !!teamDetails.data?.team);
    const roles = useFetchData(["team", teamId || '', "roles"], `__SITE_BASE__/api/v1/teams/${teamId}/roles`, !!teamDetails.data?.team);

    useEffect(() => {
        if (!socket) return;

        const handleSocket = (event: any) => handleSocketMessage(event, membersMe, queryClient, teamId!, roles);
        socket.onmessage = handleSocket;
        return () => {
            socket.onmessage = null;
        };
    }, [socket]);

    const voice = useVoice();

    useEffect(() => {
        if (!socket) return;

        const handleChannel = (event: MessageEvent) => handleChannelEvents(event, setChannelList, teamId!);
        socket.addEventListener("message", handleChannel);
        return () => socket.removeEventListener("message", handleChannel);
    }, [socket, teamId]);

    useEffect(() => {
        const channelId = voice?.channel?.id;
        if (!channelId) return;
        const channel = channelList.find(channel => channel.id === channelId);
        if (channel) {
            const index = channelList.findIndex(channel => channel.id === channelId);
            if (index === -1) return;
            const updatedChannels = [...channelList];
            const findParticipant = updatedChannels[index].participants.find((member: any) => member.id === query.data.user.id);
            if (findParticipant) {
                findParticipant.isConnecting = true;
            } else {
                updatedChannels[index].participants.push({ id: query.data.user.id, isMuted: false, isDeafned: false, isConnecting: true, attendeeId: (voice as any).attendeeId });
            }
            if (!updatedChannels[index].additionalData) updatedChannels[index].additionalData = {};
            if (!updatedChannels[index].additionalData?.attendeeById) updatedChannels[index].additionalData.attendeeById = {};
            if (updatedChannels[index].additionalData && updatedChannels[index].additionalData?.attendeeById) {
                updatedChannels[index].additionalData.attendeeById[query.data.user.id] = "receiving";
            }
            setChannelList(updatedChannels);
        }
    }, [voice?.channel?.id]);

    useEffect(() => {
        if (channels.data) setChannelList(channels.data.channels);
    }, [channels.data]);

    useEffect(() => {
        if (!channelId && teamId && channels.data) {
            const storage = JSON.parse(localStorage.getItem("lastViewedChannelByTeamId") || "{}");
            const channel = storage[teamId];
            if (channelList.some(x => x.id === channel)) {
                navigate(`/teams/${teamId}/channels/${channel}`);
            } else if (channel) {
                delete storage[teamId];
                localStorage.setItem("lastViewedChannelByTeamId", JSON.stringify(storage));
            }
        }
    }, [channelId, teamId, channelList, navigate]);

    useEffect(() => {
        if (channelId && teamId) {
            const lastViewedChannelByTeamId = JSON.parse(localStorage.getItem("lastViewedChannelByTeamId") || "{}");
            lastViewedChannelByTeamId[teamId] = channelId;
            localStorage.setItem("lastViewedChannelByTeamId", JSON.stringify(lastViewedChannelByTeamId));
        }
        if (teamId) localStorage.setItem("lastViewedTeamId", teamId);
    }, [channelId, teamId]);

    const ref = useRef<HTMLDivElement>(null);
    const [count, setCount] = useState(1);

    useEffect(() => {
        if (channelId) setCount(1);
        if (channelId && socket) socket.send(JSON.stringify({ t: "CHANNEL_MOUNTED", d: { channelId } }));
    }, [channelId]);

    useEffect(() => {
        if (!ref.current) return;
        const isMobile = window.matchMedia("(max-width: 768px)").matches;
        if (!isMobile) return;
        const hammer = new Hammer(ref.current);

        hammer.on("swiperight", () => {
            if (count < 2) setCount(prevCount => prevCount + 1);
        });
        hammer.on("swipeleft", () => {
            if (count > 0) setCount(prevCount => prevCount - 1);
        });
        return () => hammer.destroy();
    }, [ref.current, count]);

    if (query.isError) return <ErrorBox message={query.error as unknown as string} />;

    const [streamerMode, setStreamerMode] = useState(() => {
        try {
            const storedMode = localStorage.getItem("streamerMode");
            if (!storedMode) {
                localStorage.setItem("streamerMode", JSON.stringify({
                    enabled: false,
                    shortcut: null,
                    details: {
                        hidePersonalInfo: true,
                        hideInviteLinks: true,
                        hideLastMessagesOnDMs: true,
                    }
                }));
            }
            return storedMode ? JSON.parse(storedMode) : {
                enabled: false,
                shortcut: null,
                details: {
                    hidePersonalInfo: true,
                    hideInviteLinks: true,
                    hideLastMessagesOnDMs: true,
                }
            };
        } catch (e) {
            console.error(e);
            return {};
        }
    });

    useEffect(() => {
        const handleStorageChange = () => {
            try {
                const newValue = JSON.parse(localStorage.getItem("streamerMode") || "{}");
                setStreamerMode(newValue);
            }
            catch (e) {
                console.error(e);
            }
        };

        window.addEventListener("storage", handleStorageChange);

        return () => {
            window.removeEventListener("storage", handleStorageChange);
        };
    }, []);
    const [isNsfwAccepted, setIsNsfwAccepted] = useState(localStorage.getItem("nsfwAcceptedChannels")?.split(",") || []);
    const isMobile = useMediaQuery('(max-width:600px)');
    return (
        <>
            {!socket && (
                <div className="fixed top-0 items-center justify-center h-screen w-full z-50">
                    <div className="flex items-center justify-center w-full bg-yellow-400">
                        <p className="text-white font-semibold text-lg">
                            The connection to the server has been lost. Attempting to reconnect...
                        </p>
                    </div>
                </div>
            )}

            <div className={`flex flex-col h-screen relative`} ref={ref}>
                <OpenNotifications streamerMode={streamerMode} />
                <StreamerModeAlert socket={socket} streamerMode={streamerMode} />
                <VerifyEmailAlert socket={socket} streamerMode={streamerMode} user={query.data?.user} />
                <div className="flex flex-1 overflow-hidden">
                    {isMobile && (
                    <TeamsSidebar
                        socket={socket}
                        isOpen={count}
                    />
                    )}
                    <div className="flex flex-1 overflow-hidden">
                        <ChannelSidebar
                            key={teamId + "-channel-sidebar"}
                            socket={socket}
                            isOpen={count}
                        />
                        <div className="flex flex-1 overflow-y-scroll h-auto" style={{ scrollbarWidth: "none" }}>
                            {channelId ? (
                                <ChannelCheck
                                    channel={channelList?.find(channel => channel.id === channelId)}
                                    isNsfwAccepted={isNsfwAccepted}
                                    socket={socket}
                                    setIsNsfwAccepted={setIsNsfwAccepted}
                                />
                            ) : (
                                <div className="flex flex-col flex-1 items-center justify-center h-full p-4">
                                    <Icon name="hashtag" size="128" color="gray" />
                                    <p className="text-gray-300 font-semibold text-lg">
                                        Nothing to see here, select a channel to start chatting
                                    </p>
                                </div>
                            )}
                        </div>
                        {channelId &&
                            !channelList?.find(channel => channel.id === channelId)?.type.includes("watchstream") &&
                            !channelList?.find(channel => channel.id === channelId)?.type.includes("voice") &&
                            (!channelList?.find(channel => channel.id === channelId)?.nsfw || isNsfwAccepted.includes(channelId!)) &&
                            channelId !== "applications"
                            && (

                                <MembersSidebar
                                    isOpen={count}
                                    channel={channelList?.find(channel => channel.id === channelId)}
                                />
                            )}
                    </div>
                </div>
                {!isMobile && (
                    <TeamsSidebar
                        socket={socket}
                        isOpen={count}
                    />
                )}
                <Bottom setIsOpen={setCount} />
            </div>
        </>
    );
}    